import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';

export default {
  'navBar.lang': '语言',
  ...pages,
  ...menu,
  ...pwa,
};
